module.exports = __webpack_public_path__ + "static/media/nike.1082bda5.jpg";